// extracted by mini-css-extract-plugin
module.exports = {"button":"UI_button__3ph0v","buttonInverted":"UI_buttonInverted__1M0K5"};